module.exports = __webpack_public_path__ + "static/media/appstore.9b80c9ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/appstore.svg
// module id = 417
// module chunks = 37